// Module
var code = "<svg width=7 height=13 viewBox=\"0 0 7 13\" fill=none xmlns=http://www.w3.org/2000/svg> <path d=\"M3.38 12.012L6.734 8.437L6.136 7.878L3.796 10.452V0H2.951V10.426L0.624 7.878L0 8.424L3.38 12.012Z\" fill=black /> </svg> ";
// Exports
module.exports = code;